import {
    Link,
} from "react-router-dom";
import {Posts} from "./Posts";
export function Home() {
    let tiles = [];
    for (const category in Posts) {
        tiles.push(Posts[category][0]);
    }
    return <div className={"home-page"}>
        <div className={"hero-section"}>
            <div className={"hero-text"}>
                <h1>Podpora vizuálneho umenia a kultúrnej kreativity</h1>
                <p>Vytvárame priestor pre prezentáciu súčasného umenia, podporujeme tvorivú atmosféru v regióne.</p>
                <a href="/kontakt" className="button">Kontaktujte nás</a>
            </div>
            <div className="hero-image">
                <img src={"title_photo.webp"} alt={"pointa o.z. cover image"}/>
            </div>

        </div>
        <div className={"cards-wrapper"}>
            {
                tiles.map((tile) => {
                    return <div className="card" key={tile.id}>
                        <div className="card-cover" style={{
                            backgroundImage: "url(" + tile.banner + ")"
                        }}></div>

                        <div className="card-header">
                            <div className="heading">{tile.heading}</div>
                            {tile.date && <div className="date">{tile.date}</div>}
                        </div>
                        <div className="card-body">
                            {tile.content}
                            <Link to={tile.link}>Pokračovať v čítaní</Link>
                        </div>
                    </div>
                })
            }
        </div>
    </div>
}